import { fireEvent } from "lib/ga";
import { useRouter } from "next/router";
import { ComponentProps, FormEvent, useEffect, useRef } from "react";

import { TextField } from "./TextField";

export function SearchTextField({
    value,
    className,
    ...props
}: Omit<ComponentProps<typeof TextField>, "variant" | "startItem">) {
    const router = useRouter();
    const formRef = useRef<HTMLFormElement>(null);

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (value !== "") {
            fireEvent({
                event: "content_search",
                params: {
                    text: value as string
                }
            });

            if (process.env.BUILD_TARGET === "extension") {
                router.push({
                    protocol: "https",
                    host: "mix.day",
                    pathname: "/search",
                    query: {
                        text: value
                    }
                });
            } else {
                router.push({
                    pathname: "/search",
                    query: {
                        text: value
                    }
                });
            }
        }
    };

    const handleSearchClick = () => {
        if (formRef.current) {
            const submitEvent = new Event("submit", {
                bubbles: true,
                cancelable: true
            });
            formRef.current.dispatchEvent(submitEvent);
        }
    };

    // Update URL when search text is cleared
    useEffect(() => {
        if (
            value === "" &&
            router.pathname === "/search" &&
            router.query.text
        ) {
            if (process.env.BUILD_TARGET === "extension") {
                router.replace({
                    protocol: "https",
                    host: "mix.day",
                    pathname: "/search"
                });
            } else {
                router.replace({
                    pathname: "/search"
                });
            }
        }
    }, [value, router]);

    return (
        <form ref={formRef} onSubmit={handleSubmit} className={className}>
            <TextField
                size="medium"
                variant="filled"
                placeholder="콘텐츠 검색"
                value={value}
                endItem={
                    <TextField.Icon
                        name="SearchFilled"
                        onClick={handleSearchClick}
                        style={{ cursor: "pointer" }}
                    />
                }
                {...props}
            />
        </form>
    );
}
